import { render } from "./Fantom.vue?vue&type=template&id=300aa0df"
import script from "./Fantom.vue?vue&type=script&lang=js"
export * from "./Fantom.vue?vue&type=script&lang=js"

import "./Fantom.vue?vue&type=style&index=0&id=300aa0df&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__